
import postHttp from './../../plugin/extendFn/postHttp'
import loginService from './../../plugin/extendFn/loginService'

function SSOGard(to, from, next) {

  if(["Code"].indexOf(to.name)>=0 // 微信登录不做限制。 
  )
  {
    // 忽略的路由。 
    next()
  }
  else
  {
    console.log("gard >>> SSOGard ----------------------------------------");
    loginService.getLoginUser()
    .finally(()=>{
      next()
    })
  }
}

export default SSOGard;


// WEBPACK FOOTER //
// ./src/router/gard/SSOGard.js